import React from 'react';

const EnvelopeImg: React.FC = (props) => (
  <svg width="150" height="128" viewBox="0 0 150 128" {...props}>
    <g clipPath="url(#clip0)">
      <rect width="150" height="127.685" fill="white" fillOpacity="0.01" />
      <path
        d="M149.861 52.5802L91.7015 5.85771C86.9468 2.06703 81.046 0.00274658 74.9651 0.00274658C68.8843 0.00274658 62.9835 2.06703 58.2287 5.85771L0.13947 52.5802H0V127.615H150V52.5802H149.861Z"
        fill="#0065FF"
      />
      <path
        d="M131.241 15.6206H17.7126V107.545H131.241V15.6206Z"
        fill="#FAFBFC"
      />
      <path
        d="M118.271 39.8884H30.6136V41.2831H118.271V39.8884Z"
        fill="#3384FF"
      />
      <path
        d="M131.241 13.5983H17.7126V22.0711H131.241V13.5983Z"
        fill="#1DB9D4"
      />
      <path
        d="M76.4295 46.5829H30.6136V47.9776H76.4295V46.5829Z"
        fill="#3384FF"
      />
      <path
        d="M118.271 33.1938H30.6136V34.5885H118.271V33.1938Z"
        fill="#3384FF"
      />
      <path
        d="M118.271 59.9023H30.6136V61.297H118.271V59.9023Z"
        fill="#3384FF"
      />
      <path
        d="M118.271 66.5969H30.6136V67.9916H118.271V66.5969Z"
        fill="#3384FF"
      />
      <path
        d="M81.0321 73.2914H30.6136V74.6861H81.0321V73.2914Z"
        fill="#3384FF"
      />
      <path
        d="M150 127.685C124.547 127.685 108.368 123.57 98.2566 117.782C74.8954 104.254 71.9665 84.7977 47.5593 68.5495C30.265 57.0432 12.2734 53.7656 0 52.7196V127.685H150Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M0 127.685C25.5927 127.685 41.6318 123.57 51.7434 117.782C75.1046 104.254 77.9637 84.7977 102.441 68.5495C119.665 57.0432 137.727 53.7656 150 52.7196V127.685H0Z"
        fill="#6BD5E5"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="74.993"
        y1="127.699"
        x2="74.993"
        y2="52.7057"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1DB9D4" />
        <stop offset="0.12" stopColor="#38C3DA" />
        <stop offset="0.26" stopColor="#4FCBDF" />
        <stop offset="0.41" stopColor="#5FD1E2" />
        <stop offset="0.59" stopColor="#68D4E4" />
        <stop offset="0.82" stopColor="#6BD5E5" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="150" height="127.685" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EnvelopeImg;
